export default class MarkerError extends Error {
  constructor(...args: any[]) {
    super(...args);
    Error.captureStackTrace(this, MarkerError);
  }
}
